import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { billingErrorToast } from '@components/BillingError/toast';
import { UpdatePaymentMethodParams, updatePaymentMethod } from '@utils/backend-api/stripe';
import { BillingErrorPayload, normalizeBillingError } from '@utils/billingErrors';

const usePaymentMethodUpdate = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: UpdatePaymentMethodParams) => updatePaymentMethod(params),
    {
      onSuccess: () => {
        toast.success('Payment method has been updated');
      },
      onError: (error: Partial<BillingErrorPayload> & { message?: string }) => {
        billingErrorToast(normalizeBillingError(error));
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default usePaymentMethodUpdate;
